import { render } from "./ToggleSwitch.vue?vue&type=template&id=5e1d40d8&scoped=true&ts=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=5e1d40d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1d40d8"]])

export default __exports__